import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "indicator-container"
};
const _hoisted_2 = {
  key: 0,
  class: "empty-progress-indicator"
};
const _hoisted_3 = {
  key: 1,
  class: "progress-indicator"
};
export default {
  __name: 'RecruitmentProgressIndicator',
  props: {
    total: {
      type: Number,
      required: true,
      validator: value => value >= 0
    },
    showNumber: {
      type: Number,
      required: true,
      validator: value => value >= 0
    },
    current: {
      type: Number,
      required: true,
      validator: value => value >= 0
    },
    startColor: {
      type: String,
      default: '#409EFF'
    },
    endColor: {
      type: String,
      default: '#67C23A'
    }
  },

  setup(__props) {
    const props = __props;

    const getCellClass = index => {
      if (index < props.current - 1) return 'completed';
      if (index === props.current - 1) return 'current';
      if (index >= props.showNumber) return 'empty';
      return 'remaining';
    };

    const getCellStyle = index => {
      const ratio = props.showNumber > 1 ? index / (props.showNumber - 1) : 1;
      const color = interpolateColor(props.startColor, props.endColor, ratio);
      return {
        'background': color,
        // 'x': `calc(100% * ${index / props.total})`,
        // 'y': '0',
        'width': `calc(100% / ${props.total})` // 'margin': `0 calc((100% / ${props.total} - 12px) * 0.5)`,

      };
    }; // 颜色插值算法


    const interpolateColor = (start, end, ratio) => {
      const parse = hex => {
        const bigint = parseInt(hex.slice(1), 16);
        return [bigint >> 16 & 255, bigint >> 8 & 255, bigint & 255];
      };

      const [r1, g1, b1] = parse(start);
      const [r2, g2, b2] = parse(end);
      const r = Math.round(r1 + (r2 - r1) * ratio);
      const g = Math.round(g1 + (g2 - g1) * ratio);
      const b = Math.round(b1 + (b2 - b1) * ratio);
      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.total === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.total, (_, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["progress-cell", getCellClass(index)]),
          style: _normalizeStyle(getCellStyle(index))
        }, null, 6);
      }), 128))]))]);
    };
  }

};